import { useT } from '../../i18n'
import { appearanceI18n } from '../../i18n/shared/appearance'
import type { AppearancePreference } from '../../lib/appearance'
import { saveAppearancePreference } from '../../lib/appearance-save'
import { USE_REAL_API } from '../../lib/api'
import { APPEARANCE_ENABLED, useAppearanceStore } from '../../store/appearance'

const CHOICES: AppearancePreference[] = ['system', 'light', 'dark']

export function Appearance() {
  const t = useT(appearanceI18n)
  const preference = useAppearanceStore((s) => s.preference)
  const accountUserId = useAppearanceStore((s) => s.accountUserId)
  const saving = useAppearanceStore((s) => s.saving)
  const error = useAppearanceStore((s) => s.error)

  if (!APPEARANCE_ENABLED) return null

  return (
    <section className="max-w-2xl space-y-5 text-[var(--color-text)]">
      <header>
        <h2 className="text-lg font-semibold">{t.title}</h2>
        <p className="mt-1 text-sm text-[var(--color-text-muted)]">{t.description}</p>
      </header>
      <fieldset disabled={saving || (USE_REAL_API && !accountUserId)} className="space-y-2">
        <legend className="sr-only">{t.title}</legend>
        {CHOICES.map((choice) => (
          <label
            key={choice}
            className="flex min-h-[56px] cursor-pointer items-center gap-3 rounded-[var(--radius-control)] border border-[var(--color-border)] bg-[var(--color-surface)] px-4 py-3 hover:bg-[var(--color-surface-muted)] has-[:focus-visible]:shadow-[var(--shadow-focus)] has-[:checked]:border-[var(--color-focus)]"
          >
            <input
              type="radio"
              name="appearance-preference"
              value={choice}
              checked={preference === choice}
              onChange={() => { void saveAppearancePreference(choice) }}
              className="h-4 w-4 accent-[var(--color-action)]"
            />
            <span>
              <span className="block text-sm font-medium">{t.choices[choice]}</span>
              <span className="block text-xs text-[var(--color-text-muted)]">{t.help[choice]}</span>
            </span>
          </label>
        ))}
      </fieldset>
      {saving && <p role="status" className="text-sm text-[var(--color-text-muted)]">{t.saving}</p>}
      {error && <p role="alert" className="text-sm text-[var(--color-danger)]">{error === 'save_failed' ? t.saveFailed : t.signInRequired}</p>}
    </section>
  )
}
